export enum storageKeys {
  UID = 'UID',
  FCMTOKENS = 'FCMTOKENS',
  SELECTED_LANGUAGE = 'SELECTED_LANGUAGE',
  DEFAULT_COUNTRY = 'DEFAULT_COUNTRY',
  GUIDES_ISDISPLAYED = 'GUIDES_ISDISPLAYED',
  FAVORITESOFFERS = 'FAVORITESOFFERS',
  FAVORITESACCOUNTS = 'FAVORITESACCOUNTS',
  MAINERUPDATE = 'MAINERUPDATE'
}
